import { VendorLinkModel } from "./VendorLink.model";

export class VendorLink extends VendorLinkModel {
    // Add custom methods here
}
